import { useCallback, useEffect, useRef, useState } from 'react'

const DEFAULT_RESET_MS = 2000

export const useCopyToClipboard = (
  value: string,
  resetMs: number = DEFAULT_RESET_MS,
) => {
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>()

  const copy = useCallback(() => {
    navigator.clipboard
      ?.writeText(value)
      .then(() => {
        setCopied(true)

        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current)
        }

        timeoutRef.current = setTimeout(() => setCopied(false), resetMs)
      })
      .catch(() => {})
  }, [resetMs, value])

  useEffect(
    () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    },
    [],
  )

  return { copied, copy }
}
